import { useQuery } from "@tanstack/react-query";
import { Notice, NoticeListDto } from "../models/notice";
import { AxiosError } from "axios";
import { CacheKey } from "../models/cacheKey";
import { ListResponse } from "../models/response";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";

export function useNotices(
  artistId: number,
  eventId: number,
  rewardId: number,
) {
  const {
    data: notices,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<Notice[], AxiosError>({
    queryKey: [CacheKey.getNotices, eventId, rewardId],
    queryFn: async () => {
      const response = new ListResponse<NoticeListDto>(
        await HttpClient.request(
          OnSiteApi.noticeList(artistId, eventId, rewardId),
        ),
      );
      if (Array.isArray(response.data)) {
        return response.data.map((data) => {
          return new Notice(data);
        });
      } else {
        throw new Error(`Can not get notices from server`);
      }
    },
    staleTime: 1000,
  });

  return { notices, isLoading, isError, error, refetch };
}
